import { render, staticRenderFns } from "./FeedTankStrainChart.vue?vue&type=template&id=631d63a4&"
import script from "./FeedTankStrainChart.vue?vue&type=script&lang=ts&"
export * from "./FeedTankStrainChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports